import React, { useCallback, useMemo, useState, useRef  } from 'react';
import clsx from 'clsx';

import { useEditorState, useEditorActions } from '../../editor-context';
import { HtmlDocumentContainer } from './TratoFormat';
import { EditorBaseElementRoot } from './EditorBaseElement';
import { LegalSignatureElement, IndividualSignatureElement } from './Elements/SignatureElement';

export function LegacyTratoFormatPreview() {
    const { setCurrentElement } = useEditorActions()
    const { currentElement, document: doc, mode: editorMode } = useEditorState()

    const { elements, jurisdiction, participants } = doc;

    if (!elements || !elements.length) {
        return null
    }
    let statementsIndex = 0;
    let clausesIndex = 0;

    const handleClick = (element) => () => {
        setCurrentElement({ element })
    }

    return (
        <HtmlDocumentContainer>
            <div className="editor-canvas-html d-flex flex-column bg-light rounded" style={{fontSize: '12px'}}>
              {elements.map((element, i) => {

                    if (!element?.content?.length) {
                        return null;
                    }
                    if (element.type === "clause") {
                        clausesIndex++;
                    } else if (element.type === "statement") {
                        statementsIndex++;
                    }

                    return (
                        <EditorBaseElementRoot 
                            className={clsx('editor-canvas-item  editor-canvas-padding', currentElement._id === element._id && 'active')} 
                            active={currentElement._id === element._id} 
                            type={element.type}
                            editorMode={editorMode} 
                            onClick={handleClick(element)} 
                        >  
                            <ContractElement 
                                key={element._id} 
                                index={i} 
                                clausesIndex={clausesIndex} 
                                statementsIndex={statementsIndex} 
                                isSelected={currentElement._id === element._id} 
                                participants={participants} 
                                jurisdiction={jurisdiction} 
                                {...element} 
                                content={element.content.replace(/font-size/ig, 'fontSize')}
                            />
                        </EditorBaseElementRoot>
                    )})
            }
            </div>
        </HtmlDocumentContainer>

    )
}

function ContractElement({type, content = '', number, index, clausesIndex, statementsIndex, staticfield, isSelected, isContractDynamic}) {
  const { document: doc } = useEditorState()
  
  const { jurisdiction, participants } = doc;
    
    if (type === 'break') {
        return <div className="page-break"></div>
    }

    const getOrdinalNumber = (number) => {
        if (!isNaN(number)) {
            const num = String(number);
            const units = ['primera', 'segunda', 'tercera', 'cuarta', 'quinta', 'sexta', 'séptima', 'octava', 'novena'];
            const dozens = ['décima', 'vigésima', 'trigésima', 'cuadragésima', 'quincuagésima', 'sexagésima', 'septuagésima', 'octogésima', 'nonagésima'];
            const hundreds = ['centésima', 'ducentésima', 'tricentésima', 'cuadringentésima', 'quingentésima', 'sexcentésima', 'septingentésima', 'octingentésima', 'noningentésima'];
            const array = [units, dozens, hundreds];
            const word = [];
            let index = 0;
            for (let i = num.length; i > 0; i--) {
                const ordinalText = array[index][Number(num[i - 1]) - 1];
                if (ordinalText) {
                    word.unshift(ordinalText);
                }

                index++;
            }

            return word?.join(' ')?.toUpperCase();
        }

        return '';
    }

    const renderLogo = () => {
        return <div dangerouslySetInnerHTML={{__html: content }} /> 
    }

    const renderHeader = (isStatic) => {
        return (
            <div className="header-text contenteditable">
                {/* <HeaderElement participants={participants} type={type} isStatic={isStatic}> */}
                    <div dangerouslySetInnerHTML={{__html: content }} /> 
                {/* </HeaderElement> */}
            </div>
        )
    }
    const renderTitle = () => {
        return (
            <div className="simple-title contenteditable text-center font-weight-bold">
               <div dangerouslySetInnerHTML={{__html: content }} /> 
            </div>
        )
    }

    const renderText = () => {
        return (
            <div className="simple-text contenteditable">
               <div dangerouslySetInnerHTML={{__html: content }} /> 
            </div>
        )
    }

    const renderTable = () => {
        return (
            <div className="simple-text contenteditable">
                <div dangerouslySetInnerHTML={{__html: content }} /> 
            </div>
        )
    }

    const renderStatement = () => {
        return (
            <div className="statement-text contenteditable">
                <div className="statement-title"> {isContractDynamic ? statementsIndex : number ? number : index}.</div><div dangerouslySetInnerHTML={{__html: content }} /> 
            </div>
        )
    }

    const renderClause = () => {
        return (
            <div className="clause-text contenteditable">
                <div className="clause-title">{isContractDynamic ? getOrdinalNumber(clausesIndex) : number ? getOrdinalNumber(number) : getOrdinalNumber(index)}.</div><div dangerouslySetInnerHTML={{__html: content }} /> 
            </div>
        )
    }

    const renderDocumentFooter = () => {
        return (
            <div id="pageFooter">
                <div dangerouslySetInnerHTML={{__html: content }} /> 
            </div>
        )
    }

    const renderDocumentHeader = () => {
        return (
            <div id="pageHeader">
                <div dangerouslySetInnerHTML={{__html: content }} /> 
            </div>
        )
    }
 
  const renderSignature = () => {
      return <>
        <div className="signatures-content">
            {participants?.map(participant => {
              if (!content.includes(participant._id)) return null;
              const Component = participant.obligation === 'legal' ? LegalSignatureElement : IndividualSignatureElement
              return (
                <Component 
                    key={participant._id}
                    participant={participant}
                    participantId={participant._id}
                    jurisdiction={jurisdiction ?? 'mx'}
                />
              )
            })}
            {/* <div dangerouslySetInnerHTML={{__html: content }} />  */}
        </div> 
      </>
  }

  return (
    <div className={clsx("element")} style={{fontSize: 12}}>
        <div className="element-content">
            {/* {type === 'staticheader' && renderHeader(staticfield)}  */}
            {type === 'header' && renderHeader(staticfield)} 
            {type === 'document_logo' && renderLogo()} 
            {type === 'title' && renderTitle()} 
            {type === 'text' && renderText()} 
            {type === 'table' && renderTable()} 
            {type === 'statement' && renderStatement()} 
            {type === 'clause' && renderClause()} 
            {type === 'signature' && renderSignature()} 
            {type === 'document_footer' && renderDocumentFooter()} 
            {type === 'document_header' && renderDocumentHeader()} 
        </div>
    </div>
  )
}